import { gql } from "@apollo/client";
import { USER_DATA } from "../../fragments";

export const GET_USER = gql`
  ${USER_DATA}
  query Users {
    users {
      ...UserFields
      portalRole
      projectRole
      loginCheck
      employeeEducation {
        Id
        employeeId
        name
        degree
        fieldOfStudy
        percentage
        certificate
      }
      employeeEmployment {
        Id
        employeeId
        previousCompany
        offerLetter
        experienceLetter
        relieveingLetter
        isRecent
        paySlips
      }
      compensation {
        id
        employeeId
        effectiveDate
        effectivePeriod
        ctc
        variablePay
        basicSalary
        hra
        ltaAllowance
        otherAllowance
        professionalTax
        medicalInsurance
        pf
        totalDeductions
        netPayable
        fixedPay
      }
      bankAccount {
        accountNumber
        ifsc
        branch
        holderName
        bankName
        employeeId
        Id
      }

      familyDetails {
        dob
        fullname
        relation
        userId
        bloodGroup
        Id
      }
      docs {
        Id
        aadhaarNum
        aadhaarUrl
        panNum
        panUrl
        passportNum
        passportUrl
      }
    }
  }
`;

export const GET_USERS = gql`
  query userByOrg($orgId: Int!) {
    userByOrg(orgId: $orgId) {
      userId
      firstName
      lastName
      phone
      email
      portalRole
      companyEmail
      bloodType
      emergencyContact
      birthDate
      joiningDate
      leavingDate
      isActive
      gender
      address
      orgId
      maritalStatus
      role
      designation
      imageUrl
      department
      reportTo
      ctc
      location
      isStudent
      salaryTemplateId
      Rfid
      roleDetails {
        name
      }
      reportToDetails {
        firstName
      }
      bankAccount {
        accountNumber
        ifsc
        branch
        holderName
        bankName
        employeeId
        Id
      }
      familyDetails {
        dob
        fullname
        relation
        bloodGroup
        userId
        Id
      }
      docs {
        Id
        aadhaarNum
        aadhaarUrl
        panNum
        panUrl
        passportNum
        passportUrl
      }
      employeeEducation {
        Id
        employeeId
        name
        degree
        fieldOfStudy
        percentage
        certificate
      }
      employeeEmployment {
        Id
        employeeId
        previousCompany
        offerLetter
        experienceLetter
        relieveingLetter
        isRecent
        paySlips
      }
      compensation {
        id
        employeeId
        effectiveDate
        effectivePeriod
        ctc
        variablePay
        basicSalary
        hra
        ltaAllowance
        otherAllowance
        professionalTax
        medicalInsurance
        pf
        totalDeductions
        netPayable
        fixedPay
      }
    }
  }
`;

export const GET_USERS_DATA = gql`
  query userByOrg($orgId: Int!) {
    userByOrg(orgId: $orgId) {
      userId
      firstName
      lastName
      phone
      email
      isActive
      department
      companyEmail
      projectId
      location
      imageUrl
      isStudent
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($input: updateUserInput) {
    updateUser(input: $input)
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($input: createUserInput) {
    createUser(input: $input) {
      userId
    }
  }
`;

export const GET_USER_BY_TOKEN = gql`
  ${USER_DATA}
  query user($userId: String!) {
    user(userId: $userId) {
      ...UserFields
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($input: deleteUser) {
    deleteUser(input: $input)
  }
`;

export const GET_REPORTTO_ALL_USERS = gql`
  query GetReportToInactiveUserChange($userId: String) {
    getReportToInactiveUserChange(userId: $userId) {
      userId
      reportTo
      firstName
      lastName
    }
  }
`;

export const GET_USER_BY_ID = gql`
  ${USER_DATA}
  query user($userId: String!) {
    user(userId: $userId) {
      ...UserFields
      projectRole
      portalRole
      password
      firstName
      designation
      location
      absconded
      office
      typeOfEmployee
      deptDetails {
        name
        category
        deptId
      }
      salaryTemplateDetails {
        templateName
      }
      roleDetails {
        name
      }
      officeDetails {
        Id
        branch
      }
      reportToDetails {
        firstName
        lastName
      }
      employeeEducation {
        Id
        employeeId
        name
        degree
        fieldOfStudy
        percentage
        certificate
      }
      employeeEmployment {
        Id
        employeeId
        previousCompany
        offerLetter
        experienceLetter
        relieveingLetter
        isRecent
        paySlips
      }
      compensation {
        id
        employeeId
        effectiveDate
        effectivePeriod
        ctc
        variablePay
        basicSalary
        hra
        ltaAllowance
        otherAllowance
        professionalTax
        medicalInsurance
        pf
        totalDeductions
        netPayable
      }
      bankAccount {
        accountNumber
        ifsc
        branch
        holderName
        bankName
        employeeId
        Id
      }

      familyDetails {
        dob
        fullname
        relation
        userId
        bloodGroup
        Id
      }
      docs {
        Id
        aadhaarNum
        aadhaarUrl
        panNum
        panUrl
        passportNum
        passportUrl
      }
      payrollCurrency
      skillsDetails {
        skillsandExp
        employeeId
      }
    }
  }
`;

export const USER_LOGIN = gql`
  query userLogin($orgId: Int!, $token: String) {
    userLogin(orgId: $orgId, token: $token) {
      Token
      message
      userData {
        uploadResume
        userId
        firstName
        lastName
        phone
        email
        companyEmail
        bloodType
        emergencyContact
        birthDate
        joiningDate
        leavingDate
        isActive
        gender
        address
        orgId
        maritalStatus
        role
        designation
        imageUrl
        department
        reportTo
        ctc
        portalRole
        loginCheck
        salaryTemplateId
        isBlocked
        hasAcceptedPolicies
        deptDetails {
          deptId
          name
        }
        orgDetails {
          logo
          name
          address
          erpType
        }
      }
    }
  }
`;

export const GET_EMPLOYEES = gql`
  query userByOrg($orgId: Int!) {
    userByOrg(orgId: $orgId) {
      userId
      firstName
      lastName
      phone
      email
      companyEmail
      bloodType
      emergencyContact
      birthDate
      joiningDate
      leavingDate
      isActive
      gender
      address
      orgId
      maritalStatus
      role
      designation
      imageUrl
      department
      reportTo
      ctc
      location
      absconded
      portalRole
      salaryTemplateId
      Rfid
      hasAcceptedPolicies
      isStudent
      studentApplicantId
      deptDetails {
        deptId
        name
      }
      roleDetails {
        name
      }
      compensation {
        effectivePeriod
        effectiveDate
        ctc
      }
      orgDetails {
        logo
        name
        address
      }
      office
      officeDetails {
        country
        state
        branch
        city
      }
    }
  }
`;

export const GET_EMPLOYEES_FOR_MANAGERS = gql`
  query GetEmployeesForManager($managerId: String, $orgId: Int) {
    getEmployeesForManager(managerId: $managerId, orgId: $orgId) {
      userId
      firstName
      lastName
      phone
      email
      birthDate
      isActive
      department
      role
      orgId
      companyEmail
    }
  }
`;
export const GET_BIRTHDAYS = gql`
  query Birthday($orgId: Int!) {
    birthday(orgId: $orgId) {
      userId
      firstName
      lastName
    }
  }
`;
export const GET_ANNIVERSARY = gql`
  query Anniversary($orgId: Int!) {
    anniversary(orgId: $orgId) {
      firstName
      lastName
      yearsworked
    }
  }
`;

export const GET_REPORTTO = gql`
  query userByOrg($orgId: Int!) {
    userByOrg(orgId: $orgId) {
      companyEmail
      userId
      isActive
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation updateProfile($input: updateProfileInput) {
    updateProfile(input: $input)
  }
`;
export const UPDATE_PASSWORD = gql`
  mutation updatePassword($input: updatePasswordInput) {
    updatePassword(input: $input)
  }
`;
export const GET_USER_ORG_BY_USERID = gql`
  query GetUserOrgByUserId($userId: String, $orgId: Int) {
    getUserOrgByUserId(userId: $userId, orgId: $orgId) {
      userName
      firstName
      lastName
      email
      phone
      password
      department
      designation
      role
      orgId
      orgDetails {
        logo
        name
        address
      }
      portalDetails {
        roleName
      }
      deptDetails {
        deptId
        name
      }
      portalRole
      companyEmail
      joiningDate
      userId
      hasAcceptedPolicies
      typeOfEmployee
    }
  }
`;

export const GET_UPCOMING_BIRTHDAYS = gql`
  query UpcomingBirthday($orgId: Int!) {
    upcomingBirthday(orgId: $orgId) {
      userId
      firstName
      lastName
      birthDate
    }
  }
`;

export const CREATE_RESIGNATION = gql`
  mutation createResignation($input: createResignationInput) {
    createResignation(input: $input) {
      userId
    }
  }
`;

export const GET_RESIGNATION = gql`
  query getResignation($userId: String) {
    getResignation(userId: $userId) {
      userId
      reason
      dateofsubmit
      lastworkingDay
      reasonforResign
      reportTo
    }
  }
`;

export const GET_MANAGERS = gql`
  query GetManagersForUser($userId: String, $orgId: Int) {
    getManagersForUser(userId: $userId, orgId: $orgId) {
      employee {
        userId
        isManager
        level
      }
      l1Manager {
        userId
        firstName
      }
      l2Manager {
        userId
        firstName
      }
    }
  }
`;

export const CANCEL_RESIGNATION = gql`
  mutation cancelUserResignation($userId: String) {
    cancelUserResignation(userId: $userId)
  }
`;

export const DELETE_USER_IN_ORG = gql`
  mutation DeleteUserinOrg($userId: String, $deletedBy: String, $orgId: Int) {
    deleteUserinOrg(userId: $userId, deletedBy: $deletedBy, orgId: $orgId)
  }
`;

export const GET_ALL_RESIGNATIONS = gql`
  query getAllResignation($orgId: Int) {
    getAllResignation(orgId: $orgId) {
      Id
      userId
      reason
      dateofsubmit
      lastworkingDay
      reasonforResign
      reportTo
      orgId
      timelineDetails {
        noticeperiod
      }
      status
      isBoolean
      orderBy
      approvedBy
      approvedByStatus
      userDetails {
        firstName
        lastName
      }
    }
  }
`;


export const GET_USER_BY_DEPT = gql`
  query GetUsersByDepartment($department: Int) {
    getUsersByDepartment(department: $department) {
      firstName
      lastName
      compensation {
        effectivePeriod
        effectiveDate
        ctc
      }
      userId
    }
  }
`;
export const RESEND_USER_WELCOME_MAIL = gql`
  mutation ResendUserEmail($userId: String, $orgId: Int, $isResend: Boolean) {
    resendUserEmail(userId: $userId, orgId: $orgId, isResend: $isResend)
  }
`;

export const ALL_PERMANENT_DELETEUSERS = gql`
  mutation permanentDeleteUser($orgId: Int) {
    permanentDeleteUser(orgId: $orgId)
  }
`;



export const GET_ALL_RESIGNATIONS_STATUS = gql`
  query ResignationByStatus($status: String, $reportTo: String) {
    ResignationByStatus(status: $status, reportTo: $reportTo) {
      userId
      Id
      reason
      dateofsubmit
      lastworkingDay
      reasonforResign
      reportTo
      orgId
      status
      timelineDetails {
        noticeperiod
      }
      employeeDetails {
        firstName
        lastName
        imageUrl
      }

      isBoolean
      orderBy
      approvedBy
      approvedByStatus
    }
  }
`;

export const UPDATE_RESIGNATION_STATUS = gql`
  mutation updateResignationStatus($input: updateResignationInput) {
    updateResignationStatus(input: $input)
  }
`;


export const GET_NEWEMPLOYEE_JOINING = gql`
  query newEmployeeJoining($orgId: Int!) {
    newEmployeeJoining(orgId: $orgId) {
      firstName
      lastName
    }
  }
`;



export const GET_ACTIVE_EMPLOYEES_BY_DATE = gql`
  query GetActiveEmployeesByDate($fromDate: String, $toDate: String) {
    getActiveEmployeesByDate(fromDate: $fromDate, toDate: $toDate) {
      userId
      firstName
      lastName
      phone
      companyEmail
      joiningDate
      leavingDate
      isActive
      salaryTemplateDetails {
        templateId
        templateName
      }
      activeEmpComp {
        ctc
        effectiveDate
        effectivePeriod
        fixedPay
        salaryTemplateId
      }
    }
  }
`;
export const GET_USERS_BY_DEPARTMENT_NAME = gql`
  query GetUsersByDepartmentName($departmentName: String!) {
    getUsersByDepartmentName(departmentName: $departmentName) {
      userId
      firstName
      lastName
      phone
      email
      portalRole
      companyEmail
      bloodType
      emergencyContact
      birthDate
      joiningDate
      leavingDate
      isActive
      gender
      address
      orgId
      maritalStatus
      role
      designation
      imageUrl
      department
      reportTo
      ctc
      location
      isStudent
      salaryTemplateId
      Rfid
      roleDetails {
        name
      }
      reportToDetails {
        firstName
      }
      bankAccount {
        accountNumber
        ifsc
        branch
        holderName
        bankName
        employeeId
        Id
      }
      familyDetails {
        dob
        fullname
        relation
        bloodGroup
        userId
        Id
      }
      docs {
        Id
        aadhaarNum
        aadhaarUrl
        panNum
        panUrl
        passportNum
        passportUrl
      }
      employeeEducation {
        Id
        employeeId
        name
        degree
        fieldOfStudy
        percentage
        certificate
      }
      employeeEmployment {
        Id
        employeeId
        previousCompany
        offerLetter
        experienceLetter
        relieveingLetter
        isRecent
        paySlips
      }
      compensation {
        id
        employeeId
        effectiveDate
        effectivePeriod
        ctc
        variablePay
        basicSalary
        hra
        ltaAllowance
        otherAllowance
        professionalTax
        medicalInsurance
        pf
        totalDeductions
        netPayable
        fixedPay
      }
    }
  }
`;



export const GET_USER_DATA_BY_EMAIL = gql`
  query getUserDetailsByEmail($companyEmail: String) {
    getUserDetailsByEmail(companyEmail: $companyEmail) {
      userId
      firstName
      lastName
      orgId
      password
      email
      address
      isActive
      imageUrl
      companyEmail
    }
  }
`;



export const RESET_PASSWORD = gql`
  mutation resetPassword($input: ResetPasswordInput) {
    resetPassword(input: $input)
  }
`;